/** 本地配置 */
export enum ModuleName {
  /** 通用模块名 */
  /** 热门商户 */
  'HotMerchant' = 'HotMerchant',

  /** 中国内地 */
  /** 推荐模块，包含ekyc小黄条、推荐服务tab、扫码有礼组件、banner组件 */
  'Recommend' = 'Recommend',
  /** banner广告位 */
  'MerchantBanner' = 'MerchantBanner',
  /** 商圈优惠 */
  'WeCouponMall' = 'WeCouponMall',
  /** 用券引导 */
  'CouponGuide' = 'CouponGuide',
  /** 城市攻略 */
  'CityStrategy' = 'CityStrategy',
  /** 新人专区 */
  'NewUserZone' = 'NewUserZone',

  /** 中国澳门 */
  /** 旅行助手 */
  'TravelAssistant' = 'TravelAssistant',
  /** 地区推荐 */
  'AreaREcommend' = 'AreaREcommend',

  /** 日本 */
  /** 出行推荐 */
  'TravelRecommend' = 'TravelRecommend',
}

/** 额外配置 */
export type ExtraConfig = {
  /** 投放位置 id */
  modulePositionId?: string[];
};

/** 模块配置 */
export type ModuleConfig = {
  /** 模块名 */
  moduleName: ModuleName;
  /** 模块组件 */
  component: Vue.Component;
  /** 模块排序, 越小越靠前 */
  sort: number;
  /** 模块标题 */
  moduleTitle?: string;
  /** 模块投放位置信息（如果需要拉取投放计划） */
  modulePositionId?: string[];
  /** 模块内额外定制配置 */
  extraConfig?: ExtraConfig;
};

/**
 * 模块列表配置
 * 模块配置 + 模块数据
 */
export type ModuleListConfig = ModuleConfig[];

/** 弹窗列表配置 */
export type DialogListConfig = Vue.Component[];
